import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Raven from 'raven-js';
import moment from 'moment';
import { alphanumericwithspace } from '../../modules/validator';
import { Timeline } from 'antd';
import { Radio } from 'antd';
import reduxStore from '../../store';
import SideBar from '../../components/sidebar/sidebar';
import Header from '../../components/header/header';
import { Row, Col, Table, Divider, Icon, Drawer,Form, Input, Modal, message, Breadcrumb, Button, Tooltip, notification, Select } from 'antd';
import * as checkingItemActions from '../../actions/data/checkingItem';
import * as orderItemActions from '../../actions/data/orderItem';
import './checkingItem.scss';

const history = reduxStore.history;
const confirm = Modal.confirm;
const FormItem = Form.Item;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const openNotificationWithIcon = (type, message, description) => {
  notification[type]({
    message,
    description
  });
};
class CheckingItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numberOfPossibleItems : 5,
      visible: false,
      checkingItemsData: [],
      orderItemsData: [],
      createCheckingItemVisible: false,
      currentRow: {},
      editedcheckingId: '',
      checkingItemdEdited: false,
      dropdownFilter: '',
      editClicked: false,
      updated: false,
    };
    this.onChange = this.onChange.bind(this);
    this.showDrawer = this.showDrawer.bind(this);
    this.onClose = this.onClose.bind(this);
    this.showConfirm = this.showConfirm.bind(this);
    this.createCheckingItemShowDrawer = this.createCheckingItemShowDrawer.bind(this);
    this.onCreateCheckingItemClose = this.onCreateCheckingItemClose.bind(this);
    this.handleCreateCheckingItem = this.handleCreateCheckingItem.bind(this);
    this.onTableRowClick = this.onTableRowClick.bind(this);
    this.handleUpdateCheckingItem = this.handleUpdateCheckingItem.bind(this);
    this.handleDropDownSearch = this.handleDropDownSearch.bind(this);
    this.showViewDrawer = this.showViewDrawer.bind(this);
    this.onViewClose = this.onViewClose.bind(this);
  }
  componentDidMount() {
    document.title = "MRC Fabrics | CheckingItems";
    const newMaxHeight = window.innerHeight - 330;
    const possibleRows = Math.ceil(newMaxHeight/54);
    if(possibleRows > this.state.numberOfPossibleItems) {
      this.setState({numberOfPossibleItems: possibleRows});
    }
    // if(this.props.user.loginSuccess) {
    //   message.success('Logged in successfully!', 3);
    // }
    let userToken = null;
    this.props.actions.getOrderItems(userToken);
    this.props.actions.getCheckingItems(userToken);
  }
  static getDerivedStateFromProps(nextProps, currentProps) {
    console.log( nextProps)
    let userToken = null;
    // if(this.props.user.response && this.props.user.response.token) {
    //     userToken = this.props.user.response.token;
    // } else {
    //     userToken = localStorage.getItem('_token');
    // }
    if(nextProps.orderItems && nextProps.orderItems.getOrderItemSuccess) {
      nextProps.orderItems.getOrderItemSuccess = false;
      return {
        orderItemsData: nextProps.orderItems.data.listOrderItemsDTO.map(data => {data.key = data.itemId; return data})
      }
    }
    if(nextProps.checkingItems && nextProps.checkingItems.getCheckingItemSuccess) {
      nextProps.checkingItems.getCheckingItemSuccess = false;
      return {
        updated: true, 
        checkingItemsData: nextProps.checkingItems.data.listCheckingDTO.map(data => {data.key = data.checkingId; return data})
      }
    }
    if(nextProps.checkingItems && nextProps.checkingItems.createCheckingItemSuccess && !nextProps.checkingItems.createCheckingItemPending) {
      nextProps.checkingItems.createCheckingItemSuccess = false;
      nextProps.actions.getCheckingItems(userToken);
      nextProps.form.resetFields();
      message.success('CheckingItem created successfully!', 2);
      return {
        updated: false,
        currentRow: {},
        createCheckingItemVisible: false
      };
    }
     if(nextProps.checkingItems && nextProps.checkingItems.updateCheckingItemSuccess && !nextProps.checkingItems.updateCheckingItemPending) {
      nextProps.checkingItems.updateCheckingItemSuccess  = false;
      nextProps.actions.getCheckingItems(userToken);
      nextProps.form.resetFields();
      message.success('CheckingItem edited successfully!', 2);
      return {
        visible: false,
        editClicked: false,
        currentRow: {},
        checkingItemdEdited: true,
        updated: false
      };
  }
  if(nextProps.checkingItems && nextProps.checkingItems.deleteCheckingItemSuccess && !nextProps.checkingItems.deleteCheckingItemPending) {
    nextProps.checkingItems.deleteCheckingItemSuccess = false;  
    nextProps.actions.getCheckingItems(userToken);
    message.success('CheckingItem deleted successfully!', 2);
    return {
      currentRow: '',
      updated: false
    };
    }
    if(nextProps.checkingItems && nextProps.checkingItems.error) {
      if(nextProps.checkingItems.error.message)
        message.error(nextProps.checkingItems.error.message,2);
        nextProps.checkingItems.error = {};
      //   Raven.setExtraContext({
      //       props: this.props
      //   });
      // Raven.captureException(nextProps.checkingItems.error.message, { extra: nextProps });
      if(nextProps.checkingItems.error.message === "Failed to fetch") {
        openNotificationWithIcon("error", "It looks like you've lost your internet connection", "But you probably already knew that! This must be frustrating, Don't leave us, we track these things and resume automatically! Until then just relax!! ");           
      }
    }
  return null;
    
   
    
}
  handleDropDownSearch(dropdownFilter) {
    if(!dropdownFilter)
      dropdownFilter='';
    this.setState({dropdownFilter});
  }
  onTableRowClick(currentRow) {
    this.setState({currentRow,checkingItemdEdited: false, editedcheckingId: ''});
  }
  showConfirm() {
    let userToken = null;
    // if(this.props.user.response && this.props.user.response.token) {
    //     userToken = this.props.user.response.token;
    // } else {
    //     userToken = localStorage.getItem('_token');
    // }
    const deleteCheckingItem = () => {
      this.props.actions.deleteCheckingItem(this.state.currentRow.checkingId, userToken);
    } 
    const resetFields = () => {
      this.setState({currentRow: ''});
    }
    confirm({
      title: 'Are you sure delete this CheckingItem?',
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        deleteCheckingItem();
      },
      onCancel() {
        resetFields();
        console.log('Cancel');
      },
    });
  }
  onChange(pagination, filters, sorter) {
    console.log('params', pagination, filters, sorter);
  }  
  onViewClose (){
    this.setState({
      viewVisible: false,
      currentRow: ''
    });
  }
  showViewDrawer (){
    this.setState({
      viewVisible: true,
    });
  }
  createCheckingItemShowDrawer = () => {
    this.props.form.resetFields();
    this.setState({
      createCheckingItemVisible: true,
    });
  };

  onCreateCheckingItemClose = () => {
    this.props.form.resetFields();
    this.setState({
      createCheckingItemVisible: false,
    });
  };
  handleCreateCheckingItem = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let userToken = null;
        // if(this.props.user.response && this.props.user.response.token) {
        //     userToken = this.props.user.response.token;
        // } else {
        //     userToken = localStorage.getItem('_token');
        // }
        values.itemId = parseInt(values.itemId,10);
        values.originalQty = parseInt(values.originalQty,10);
        values.defectQty = parseInt(values.defectQty,10);
        values.defectMts = parseInt(values.defectMts,10);
        values.finalValidQty = parseInt(values.finalValidQty,10);
        this.props.actions.createCheckingItem(values, userToken);
      }
    });
  }
  handleUpdateCheckingItem = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let userToken = null;
        // if(this.props.user.response && this.props.user.response.token) {
        //     userToken = this.props.user.response.token;
        // } else {
        //     userToken = localStorage.getItem('_token');
        // }
        values.premium = values.premium === "true";
        this.setState({editedcheckingId: this.state.currentRow.checkingId});
        this.props.actions.updateCheckingItem(this.state.currentRow.checkingId, values, userToken);
      }
    });
  }
  showDrawer (){
    this.props.form.resetFields();
    this.setState({
      visible: true,
      editClicked: true
    });
  }
  onClose (){
    this.setState({
      visible: false,
      editClicked: false,
      currentRow: {}
    });
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const columns = [{
      title: 'Invoice No',
      dataIndex: 'invoiceNum',
      sorter: (a, b) => { return a.invoiceNum.localeCompare(b.invoiceNum)}
    }, {
      title: 'OriginalQty',
      dataIndex: 'originalQty',
      sorter: (a, b) => { return a.originalQty.localeCompare(b.originalQty)},
      render: (text, record) => {
        if(text && text.length > 50) {
          return text.substring(0,50)+'...';
        } else {
          return text;
        }
      }
    }, {
      title: 'FinalValidQty',
      dataIndex: 'finalValidQty',
      sorter: (a, b) => { return a.finalValidQty.localeCompare(b.finalValidQty)}
    },
    {
      title: 'Status',
      dataIndex: 'status',
      sorter: (a, b) => { return a.status.localeCompare(b.status)},
    },
    {
      title: 'Action',
      key: 'action',
      width: 240,
      render: (text, record) => (
        <span>
         <Tooltip title="View CheckingItem">
            <span onClick={this.showViewDrawer} className="cursor-pointer"><Icon type="eye" /> View</span>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip title="Edit CheckingItem">
            <span onClick={this.showDrawer} className="cursor-pointer"><Icon type="edit" /> Edit</span>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip title="Delete CheckingItem">
            <span  onClick={this.showConfirm} className="cursor-pointer"><Icon type="delete" /> Delete</span>
          </Tooltip>
          {record.idcheckingItem === this.state.editedcheckingId && this.state.checkingItemdEdited ? <span className={"success"} style={{fontSize: 11,paddingLeft: 10,color: 'green'}}>updated!</span> : null}
        </span>
      )
    }];
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return(
      <Row>
        <Col 
          xs={6} 
          sm={6}
          md={4}
          lg={4}
          xl={4}
          className="height-100">
          <SideBar changePath={history.push} {...history}/>
        </Col>
        <Col
          xs={18} 
          sm={18}
          md={20}
          lg={20}
          xl={20} className="height-100-55 dashboard">
            <Row>
              <Header />
              <Row className="contents-main">
                    <div className="breadcrumb-div">
                    <Breadcrumb>
                      <Breadcrumb.Item>Home</Breadcrumb.Item>
                      <Breadcrumb.Item>CheckingItem</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="add-checkingItem-button">
                        <Button type="primary" className="login-form-button" style = {{
                          width: 200,
                          float: 'right',
                          marginTop: -30
                        }}onClick={this.createCheckingItemShowDrawer}>
                        <Icon type="plus" /> Add CheckingItem
                        </Button>
                    </div>
                    </div>
                    <div className="main-table-div">
                      <Table 
                        className="main-table" 
                        columns={columns} 
                        dataSource={this.state.checkingItemsData} 
                        pagination={{pageSize:this.state.numberOfPossibleItems}} 
                        loading={this.state.checkingItemsData.length === 0&& !this.state.updated}
                        locale={{ emptyText: 'No checkingItems added!' }}
                        onChange={this.onChange} onRow={(record, index) => ({
                          onClick: (event) => { this.onTableRowClick(record); } 
                      })}/>
                    </div>
                </Row>
                <Drawer
                  title="Add CheckingItem"
                  placement="right"
                  closable={false}
                  onClose={this.onCreateCheckingItemClose}
                  visible={this.state.createCheckingItemVisible}
                  width={450}
                >
                  <Form onSubmit={this.handleCreateCheckingItem} className="checkingItem-create" id="createCheckingItem">
                        <FormItem
                            {...formItemLayout}
                            label="Item"
                            >
                            {getFieldDecorator('itemId', {
                                rules: [{ required: true, message: 'Please select item!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                              <Select 
                                style={{ width: "100%" }}
                              >
                                {(this.state.orderItemsData.length)? 
                                  this.state.orderItemsData.map(item => 
                                  <Option value={item.itemId.toString()} key={'receipt'+item.itemId}>{item.itemId}</Option>
                                  ): ''}
                            </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Invoice No"
                            >
                            {getFieldDecorator('invoiceNum', {
                                rules: [{ required: true, message: 'Please enter invoice number!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Done By"
                            >
                            {getFieldDecorator('doneBy', {
                                rules: [{ required: true, message: 'Please enter doneBy!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Original Qty"
                            >
                            {getFieldDecorator('originalQty', {
                                rules: [{ required: true, message: 'Please enter originalQty!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="DefectQty"
                            >
                            {getFieldDecorator('defectQty', {
                                rules: [{ required: true, message: 'Please enter defectQty!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="DefectMts"
                            >
                            {getFieldDecorator('defectMts', {
                                rules: [{ required: true, message: 'Please enter defectMts!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="FinalValidQty"
                            >
                            {getFieldDecorator('finalValidQty', {
                                rules: [{ required: true, message: 'Please enter finalValidQty!', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Status"
                            >
                            {getFieldDecorator('status', {
                                rules: [{ required: true, message: 'Please enter status', whitespace: true }, {validator: alphanumericwithspace}],
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <br/><br/><br/>
                        <div
                            style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            borderTop: '1px solid #e8e8e8',
                            padding: '10px 16px',
                            textAlign: 'right',
                            left: 0,
                            background: '#fff',
                            borderRadius: '0 0 4px 4px',
                            }}
                        >
                            <FormItem {...tailFormItemLayout} className="submit-buttons-edit-profile">
                                <Button type="primary" htmlType="submit">Create</Button>
                                <Button type="default" className="edit-profile-cancel" onClick={this.onCreateCheckingItemClose}>Cancel</Button>
                            </FormItem>
                        </div>
                        </Form>
                </Drawer>
            <Drawer
                title="Edit CheckingItem"
                placement="right"
                closable={false}
                onClose={this.onClose}
                visible={this.state.visible}
                width={450}
              >
              <Form onSubmit={this.handleUpdateCheckingItem} className="checkingItem-create" id="createCheckingItem">
                       <FormItem
                            {...formItemLayout}
                            label="Item"
                            >
                            {getFieldDecorator('itemId', {
                                rules: [{ required: true, message: 'Please select item!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.itemId : null
                            })(
                              <Select 
                                style={{ width: "100%" }}
                              >
                                {(this.state.orderItemsData.length)? 
                                  this.state.orderItemsData.map(item => 
                                  <Option value={item.itemId.toString()} key={'receipt'+item.itemId}>{item.itemId}</Option>
                                  ): ''}
                            </Select>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Invoice No"
                            >
                            {getFieldDecorator('invoiceNum', {
                                rules: [{ required: true, message: 'Please enter Invoice Number!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.invoiceNum : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Done By"
                            >
                            {getFieldDecorator('doneBy', {
                                rules: [{ required: true, message: 'Please enter doneBy!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.doneBy : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Original Qty"
                            >
                            {getFieldDecorator('originalQty', {
                                rules: [{ required: true, message: 'Please enter Original Qty!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.checkingItemAddr3 : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="DefectQty"
                            >
                            {getFieldDecorator('defectQty', {
                                rules: [{ required: true, message: 'Please enter defectQty!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.defectQty : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="DefectMts"
                            >
                            {getFieldDecorator('defectMts', {
                                rules: [{ required: true, message: 'Please enter defectMts!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.defectMts : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="FinalValidQty"
                            >
                            {getFieldDecorator('finalValidQty', {
                                rules: [{ required: true, message: 'Please enter finalValidQty!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.finalValidQty : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="Status"
                            >
                            {getFieldDecorator('status', {
                                rules: [{ required: true, message: 'Please enter status!', whitespace: true }, {validator: alphanumericwithspace}],
                                initialValue: this.state.editClicked ? this.state.currentRow.status : null
                            })(
                                <Input />
                            )}
                        </FormItem>
                        <br/><br/><br/>
                        <div
                            style={{
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            borderTop: '1px solid #e8e8e8',
                            padding: '10px 16px',
                            textAlign: 'right',
                            left: 0,
                            background: '#fff',
                            borderRadius: '0 0 4px 4px',
                            }}
                        >
                            <FormItem {...tailFormItemLayout} className="submit-buttons-edit-profile">
                                <Button type="primary" htmlType="submit">Update</Button>
                                <Button type="default" className="edit-profile-cancel" onClick={this.onClose}>Cancel</Button>
                            </FormItem>
                        </div>
                        </Form>
              </Drawer>
              <Drawer
                title="View CheckingItem"
                placement="right"
                closable={false}
                onClose={this.onViewClose}
                visible={this.state.viewVisible}
                width={500}
              >
                    
                    <p>ItemId : {this.state.currentRow.itemId ? <b>{this.state.currentRow.itemId}</b> : 'Not Provided.'}</p>
                    <p>Invoice No : {this.state.currentRow.invoiceNum ? <b>{this.state.currentRow.invoiceNum}</b> : 'Not Provided.'}</p>
                    <p>Done By : {this.state.currentRow.doneBy ? <b>{this.state.currentRow.doneBy}</b> : 'Not Provided.'}</p>
                    <p>Original Qty : {this.state.currentRow.originalQty ? <b>{this.state.currentRow.originalQty}</b> : 'Not Provided.'}</p>
                    <p>Defect Qty : {this.state.currentRow.defectQty ? <b>{this.state.currentRow.defectQty}</b> : 'Not Provided.'}</p>
                    <p>Defect Mts : {this.state.currentRow.defectMts ? <b>{this.state.currentRow.defectMts}</b> : 'Not Provided.'}</p>
                    <p>FinalValidQty : {this.state.currentRow.finalValidQty ? <b>{this.state.currentRow.finalValidQty}</b> : 'Not Provided.'}</p>
                    <p>Status : {this.state.currentRow.status ? <b>{this.state.currentRow.status}</b> : 'Not Provided.'}</p>
                    
                   
              </Drawer>
            </Row>
        </Col>
      </Row>
    );
  }
}
const WrappedCheckingItem = Form.create()(CheckingItem);
function mapStateToProps(state) {
  return {
    user: state.user,
    checkingItems: state.checking,
    orderItems: state.orderItem
  };
}

function mapDispatchToProps(dispatch) {
  return {
      actions: bindActionCreators(Object.assign({}, checkingItemActions, orderItemActions), dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedCheckingItem)